import { createContext } from "react";

const modalContext = createContext({
    showModal: null,
    setShowModal: (showModal)=>{},
    modalDetails: null,
    setModalDetails: (modalDetails)=>{},
    profileDetails: null,
    setProfileDetails: (profileDetails)=>{},
    modal: null,
    setModal: (modal)=>{},
    load: null,
    setLoad: (load)=>{},
});

export default modalContext;